import React from 'react';

import { useOfficeDrones } from '@/components/Ajax';

export default function useGetTextAnalyticsInfo({ params = {}, settings = {} }) {
	return useOfficeDrones('/projects/info', params, settings, 'get');
}
